import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {Button} from '../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {VisualSizesEnum} from '../../../libs/shared/ui/src/styles/commonStyles';
import {PaletteColorsEnum} from '../../../libs/shared/ui/src/styles/paletteModel';
import teamWorkspaceImage from '../../assets/images/bubbleTeamsInbox.png';
import {OnboardingTipTypesEnum} from '../../models/api/preferencesModel';
import {Image} from '../common/image';
import {InfoBubble, InfoBubbleInstanceProps} from '../common/infoBubbles/infoBubble';
import {InfoBubbleContent} from '../common/infoBubbles/infoBubbleContent';
import {InfoBubbleDescription} from '../common/infoBubbles/infoBubbleContentDescription';
import {InfoBubbleTitle} from '../common/infoBubbles/infoBubbleContentTitle';
import {InfoBubbleFooterActions} from '../common/infoBubbles/infoBubbleFooterActions';
import {useInfoBubblesContext} from '../common/infoBubbles/infoBubblesContext';

/*
 * Component.
 */

export const TeamWorkspaceInfoBubble: FC<InfoBubbleInstanceProps> = ({targetRef}) => {
  const context = useInfoBubblesContext();
  const onClose = () => context.closeInfoBubbles(OnboardingTipTypesEnum.TEAM_WORKSPACE);

  return (
    <InfoBubble
      {...context}
      type={OnboardingTipTypesEnum.TEAM_WORKSPACE}
      position="right"
      targetRef={targetRef}
      isInteractive
    >
      <InfoBubbleContent>
        <Image src={teamWorkspaceImage} width={648} height={392} />
        <InfoBubbleTitle>
          <Trans id="infobubble-teamworkspace-title">Your team workspace</Trans>
        </InfoBubbleTitle>
        <InfoBubbleDescription>
          <Trans id="infobubble-teamworkspace-description">
            All of your team inboxes live here. Everyone on your team can see these messages.
          </Trans>
        </InfoBubbleDescription>
        <InfoBubbleFooterActions>
          <Button
            onClick={onClose}
            size={VisualSizesEnum.MEDIUM}
            color={PaletteColorsEnum.PINK}
            variant={ButtonVariantsEnum.CUSTOM}
          >
            <Trans id="infobubble-teamworkspace-cta">Got it</Trans>
          </Button>
        </InfoBubbleFooterActions>
      </InfoBubbleContent>
    </InfoBubble>
  );
};
